import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GET_ORGANIZATION_LIST_PATH } from 'ze-api-contract/user-v2/get-organization-list';
const _orgListKeys = createQueryKeys('organization', {
    organizationList: (userEmail)=>({
            queryKey: [
                GET_ORGANIZATION_LIST_PATH,
                userEmail
            ]
        })
});
export const orgListKeys = _orgListKeys;
